export enum ChallengeType {
  Challenge = 'challenge',
  PracticePlan = 'practice_plan',
}
